import { useTeams } from '@/hooks/useTeams';
import { supabase } from '@/lib/supabase';
import { callApi } from '@/utils/api';
import { getFacebookMediaQueryKey } from '@/utils/query-keys';
import { useQuery } from '@tanstack/react-query';

export type FacebookMediaInsight = {
  id: string;
  facebook_media_id: string;
  name: string;
  title: string;
  description: string;
  value: {
    value: number;
  };
  timestamp: string;
};

export type FacebookMediaMetric = {
  id: string;
  facebook_media_id: string;
  comments_count: number;
  like_count: number;
  timestamp: string;
};

export type FacebookMedia = {
  id: string;
  facebook_account_id: string;
  caption: string | null;
  media_description: string | null;
  media_type: 'VIDEO' | 'IMAGE';
  media_url?: string;
  thumbnail_url: string | null;
  media_insights: FacebookMediaInsight[];
  media_metrics: FacebookMediaMetric;
  timestamp: string;
};

export const useFacebookMedia = () => {
  const { activeTeam } = useTeams();

  return useQuery({
    queryKey: getFacebookMediaQueryKey(),
    queryFn: async (): Promise<FacebookMedia[]> => {
      const { data, error } = await callApi(supabase, '/facebook/media');

      if (error) throw error;

      return data;
    },
    enabled: !!activeTeam,
  });
};
